import { GenericBackendResponse } from '../genericBackendResponse';

export interface SignedTransferBulletins {
	/**
	 * Peticiones del usuario cuyo boletín YA está firmado.
	 *
	 * Lo que no está aquí es «no consta firmado», no «sin firmar»: si comparsa no
	 * puede consultarlo, devuelve la lista vacía a propósito. Se prefiere enseñar
	 * el botón de más a escondérselo a quien todavía tiene que firmar.
	 */
	signedTransferIds: string[];
}

/** De las peticiones del usuario, cuáles tienen ya su boletín firmado. */
const getSignedTransferBulletins = async (
	token: string
): Promise<GenericBackendResponse<SignedTransferBulletins>> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/kyc/signed-transfer-bulletins`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	);

	if (!response.ok) {
		throw new Error(`signed-transfer-bulletins failed: ${response.status}`);
	}

	return response.json();
};

export default getSignedTransferBulletins;
